<template>
  <div>
    <div v-if="solutionsListInited">
      <div v-if="otherSolutionsList.length > 0">
        <div class="panel-list" id="panel-list">
          <div v-for="(otherSolution, index) in otherSolutionsList" v-bind:key="otherSolution.solutionId">
            <div @click="showSolutionByIndex(index)">
              <div class="panel panel-clickable" :class="{'seen': seenSolutionIds.has(otherSolution.solutionId), 'last-seen': otherSolution.solutionId === lastSeenSolutionId}">
                <div class="panel-body flex">
                  <div class="col-xs-5 col-lg-4 flex">
                    <span><img :src="otherSolution.profileImage" class="profile-image"></span>
                    <span class="nickname"><strong>{{ otherSolution.publicUserName }}</strong></span>
                  </div>
                  <div class="hidden-xs col-lg-2">
                    <div class="date">{{ getNiceTime(otherSolution.timeSolved) }}</div>
                  </div>
                  <div class="col-xs-2 flex">
                    <span v-if="otherSolution.commentCount"><i
                      class="icon dev-chat-dots"></i><span>{{ otherSolution.commentCount }} <span class="hidden-xs">Kommentar<span
                      v-if="otherSolution.commentCount !== 1">e</span></span></span></span>
                  </div>
                  <div class="col-xs-5 col-lg-4 flex star-rating-col">
                    <span>
                      <star-rating size="1.6rem" :disabled="true" name="rate"
                                   :value="otherSolution.rating"
                      ></star-rating>
                    </span>
                    <span v-if="otherSolution.ratingCount > 0"
                          class="hidden-xs">{{ otherSolution.rating.toFixed(1) }} bei {{ otherSolution.ratingCount }} Bewertung<span
                        v-if="otherSolution.ratingCount !== 1">en</span></span>
                    <span v-if="otherSolution.ratingCount <= 0" class="hidden-xs">noch nicht bewertet</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="text-center" v-if="isLoadingMoreSolutions">
            <i class="loading-spinner loading-spinner-big loading-spinner-green"></i>
          </div>
        </div>
      </div>
      <div v-if="otherSolutionsList.length <= 0 && view === 'ratedByMe'">
        <div class="panel-list error-message">
          <img class="error-icon"
               src="https://res.cloudinary.com/dspi5zyaa/image/upload/v1654601415/eh-platform/icons/smashicons_computer_diagnostics_sad-computer-90-icon-cartoony.svg">
          <span>Du hast noch keine Lösungen bewertet.</span>
        </div>
      </div>
    </div>
    <div v-if="!otherSolutionsRequest.loaded">
      <other-solutions-list-loading-indicator></other-solutions-list-loading-indicator>
    </div>
    <div v-if="loaded && error" class="error-message">
      <img class="error-icon"
           src="https://res.cloudinary.com/dspi5zyaa/image/upload/v1643639005/eh-platform/icons/smashicons_website_elements_website-error-28-icon-cartoony.svg">
      <span>Es ist ein <strong>Fehler</strong> beim Laden der Lösung aufgetreten :(</span>
    </div>
    <other-solution-modal
        v-if="solutionData != null"
        :isVisible="isModalVisible"
        :solutionData="solutionData"
        :task-solutions="taskSolutions"
        :challengeData="challengeData"
        :previous-index="previousIndex"
        :next-index="nextIndex"
        :isloading-more-solutions="isLoadingMoreSolutions || otherSolutionsByIdRequest.isLoading"
        @showSolution="showSolutionByIndex"
        @addedRating="addedRatingHandler"
        @close="closeModal">
    </other-solution-modal>
  </div>
</template>

<script>
import {eventBus, services} from "../../main";
import StarRating from "../StarRating";
import OtherSolutionsListLoadingIndicator from "../OtherSolutionsListLoadingIndicator";
import OtherSolutionModal from "./OtherSolutionModal";
import moment from "moment";

export default {
  name: "OtherSolutionsList",
  components: {OtherSolutionModal, StarRating, OtherSolutionsListLoadingIndicator},
  props: {
    taskId: {type: String, default: "", required: true},
    view: {type: String, required: true},
    challengeData: {
      type: [Object],
      default() {
        return {}
      }
    },
  },
  data() {
    return {
      ratedSolutionsRequest: services.rankTheCodeService.getRatedSolutions(),
      otherSolutionsRequest: {loaded: true, error: null,},
      moreOtherSolutionsRequest: {loaded: true, error: null,},
      otherSolutionsByIdRequest: {loaded: true, error: null,},
      taskSolutionsRequest: {loaded: true, error: null,},
      pageId: 1,
      numPages: 0,
      numberOfSolutionsPerPage: 20,
      solutionsListInited: false,
      otherSolutionsList: [],
      publicUserProfilesRequest: {loaded: false, error: null},
      publicUserIdMap: new Map(),
      isModalVisible: false,
      solutionData: null,
      taskSolutions: [],
      taskSolutionMap: new Map(),
      tmpSolutionMap: new Map(),
      currentSolutionId: null,
      lastSeenSolutionId: null,
      seenSolutionIds: new Set(),
      selectedSolutionId: this.$route.query.solutionId || null,
      isLoadingMoreSolutions: false,
      previousIndex: -1,
      nextIndex: -1,
      maxIndex: -1,
    }
  },
  mounted() {
    eventBus.$on("rank-the-code-comments-updated", (data) => {
      if (!data) {
        data = {
          'solutionId': this.currentSolutionId,
          'addedCommentCount': 1,
        }
      }
      this.updateSolutionRatingData(data);
    });
    eventBus.$on("newCommentAdded", (count) => {
      this.updateSolutionRatingData({
        'solutionId': this.currentSolutionId,
        'addedCommentCount': count,
      });
    });
    eventBus.$on("show-task-solution", (taskSolution) => {
      const solutionId = taskSolution.solutionId;
      let solutionData = null;
      if (taskSolution.taskId === this.taskId) {
        solutionData = this.otherSolutionsList.find((solution) => solution.solutionId === solutionId);
      } else if (this.tmpSolutionMap.has(solutionId)) {
        solutionData = this.tmpSolutionMap.get(solutionId);
      }
      if (solutionData) {
        this.showModal(solutionData);
        return;
      }
      this.selectedSolutionId = solutionId;
      this.otherSolutionsByIdRequest = services.rankTheCodeService.getOtherSolutionRatingsById(solutionId);
      this.otherSolutionsByIdRequest.isLoading = true;
    });
    eventBus.$on('show-other-solution', (data) => {
      const solutionIndex = this.otherSolutionsList.findIndex((solution) => solution.solutionId === data.solutionId);
      // if solution is already in list
      if (solutionIndex !== -1) {
        this.$nextTick(() => {
          this.showSolutionByIndex(solutionIndex);
        });
        return;
      }
      // if solution is in tmp solution map
      else if (this.tmpSolutionMap.has(data.solutionId)) {
        const solutionData = this.tmpSolutionMap.get(data.solutionId);
        this.$nextTick(() => {
          this.showModal(solutionData);
        });
        return;
      }
      // request solution and show after request
      this.selectedSolutionId = data.solutionId;
      this.otherSolutionsByIdRequest = services.rankTheCodeService.getOtherSolutionRatingsById(this.selectedSolutionId);
      this.otherSolutionsByIdRequest.isLoading = true;
    });
    window.onscroll = () => {
      // check if we are on the bottom of the page
      const bottomOfWindow = window.innerHeight + window.scrollY >= document.body.offsetHeight - 2;
      if(bottomOfWindow && this.pageId < this.numPages && !this.isLoadingMoreSolutions) {
        // block reloading of solutions while loading more solutions
        this.isLoadingMoreSolutions = true;
        this.loadNext();
      }
    }
    if (this.selectedSolutionId) {
      this.otherSolutionsByIdRequest = services.rankTheCodeService.getOtherSolutionRatingsById(this.selectedSolutionId);
      let query = Object.assign({}, this.$route.query);
      delete query.solutionId;
      // dirty hack to remove query params from url, so we catch the error linking to the same site
      this.$router.replace({query}).catch(()=>{});
    }
    else {
      this.loadOtherSolutions(1);
    }
  },
  beforeDestroy() {
    this.enableScrolling();
    eventBus.$off('rank-the-code-comments-updated');
    eventBus.$off('newCommentAdded');
    eventBus.$off('show-task-solution');
    // don't remove 'show-other-solution', because CampaignDetailsView still uses it
  },
  computed: {
    loaded: function () {
      return this.otherSolutionsRequest.loaded && this.publicUserProfilesRequest.loaded;
    },
    error: function () {
      return this.otherSolutionsRequest.error || this.publicUserProfilesRequest.error || this.moreOtherSolutionsRequest.error;
    },
  },
  watch: {
    "taskId": function () {
      this.pageId = 1;
      this.solutionsListInited = false;
      this.loadOtherSolutions(this.pageId);
    },
    "view": function () {
      this.pageId = 1;
      this.solutionsListInited = false;
      this.loadOtherSolutions(this.pageId);
    },
    "otherSolutionsByIdRequest.loaded": function () {
      if (this.otherSolutionsByIdRequest.loaded && !this.otherSolutionsByIdRequest.error) {
        this.otherSolutionsByIdRequest.isLoading = false;
        if (!this.otherSolutionsByIdRequest.error) {
          this.requestPublicUserProfiles([this.otherSolutionsByIdRequest.apiData]);
        }
        else {
          this.selectedSolutionId = null;
          this.loadOtherSolutions(1);
        }
      }
    },
    "otherSolutionsRequest.loaded": function () {
      this.numPages = 0;
      if (this.otherSolutionsRequest.loaded && !this.otherSolutionsRequest.error && this.otherSolutionsRequest.apiData) {
        this.requestPublicUserProfiles(this.otherSolutionsRequest.apiData);
        if (this.otherSolutionsRequest.pagination) {
          this.numPages = this.otherSolutionsRequest.pagination.numPages;
        }
      }
    },
    "moreOtherSolutionsRequest.loaded": function() {
      if (this.moreOtherSolutionsRequest.loaded && !this.moreOtherSolutionsRequest.error && this.moreOtherSolutionsRequest.apiData) {
        this.requestPublicUserProfiles(this.moreOtherSolutionsRequest.apiData);
      }
    },
    "publicUserProfilesRequest.loaded": function () {
      if (this.publicUserProfilesRequest.loaded && !this.publicUserProfilesRequest.error) {
        this.createPublicUserIdMap(this.publicUserProfilesRequest.apiData);
        if (this.selectedSolutionId && this.otherSolutionsByIdRequest.loaded && !this.otherSolutionsByIdRequest.error) {
          this.selectedSolutionId = null;
          let solutionData = this.createSolutionListEntry(this.otherSolutionsByIdRequest.apiData);
          this.tmpSolutionMap.set(solutionData.solutionId, solutionData);
          this.$nextTick(() => {
            // open this solution without previous and next button navigation
            this.showModal(solutionData);
          });
          // if solutions list hasn't been loaded yet (when a solution id was set by get parameter in query)
          if (!this.solutionsListInited) {
            this.loadOtherSolutions(1);
          }
          return;
        }
        if (this.solutionsListInited) {
          this.updateSolutionsList();
        }
        else {
          this.initSolutionsList();
        }
      }
    },
    "taskSolutionsRequest.loaded": function () {
      if (this.taskSolutionsRequest.loaded && !this.taskSolutionsRequest.error) {
        const taskSolutions = [];
        const publicUserId = this.taskSolutionsRequest.publicUserId;
        if (this.taskSolutionsRequest.apiData.length !== 0) {
          for (let taskData of this.challengeData.tasks) {
            const taskSolutionData = this.taskSolutionsRequest.apiData.find((data) => data.taskId === taskData.task_id);
            taskSolutions.push({
              'taskId': taskData.task_id,
              'solutionId': taskSolutionData ? taskSolutionData.solutionId : null,
              'publicUserId': publicUserId,
            });
          }
        }
        this.taskSolutionMap.set(publicUserId, taskSolutions);
        this.taskSolutions = taskSolutions;
      }
    },
  },
  methods: {
    getNiceTime: function(timestamp) {
      moment.locale("de");
      let dateString = moment(timestamp).format("DD.MM.YY");
      if (moment(timestamp).isSame(moment(), "day")) {
        dateString = moment(timestamp).fromNow();
      }
      return dateString;
    },
    requestPublicUserProfiles: function(apiData) {
      const publicUserIds = this.getPublicUserIds(apiData);
      this.publicUserProfilesRequest = services.userService.getDataForPublicUserIds(publicUserIds);
    },
    updateSolutionsList: function() {
      if (this.moreOtherSolutionsRequest.loaded && !this.moreOtherSolutionsRequest.error) {
        if (Array.isArray(this.moreOtherSolutionsRequest.apiData)) {
          for (const solution of this.moreOtherSolutionsRequest.apiData) {
            this.checkListForSolution(solution);
          }
          if (this.moreOtherSolutionsRequest.pagination) {
            this.numPages = this.moreOtherSolutionsRequest.pagination.numPages;
          }
          if (this.moreOtherSolutionsRequest.nextIndex) {
            this.showSolutionByIndex(this.moreOtherSolutionsRequest.nextIndex);
            delete this.moreOtherSolutionsRequest.nextIndex;
          }
        }
      }
      // now more solutions can be loaded
      if (this.moreOtherSolutionsRequest.loaded) {
          this.isLoadingMoreSolutions = false;
      }
      if (this.pageId === this.numPages) {
        this.maxIndex = this.otherSolutionsList.length;
      }
    },
    initSolutionsList: function () {
      this.otherSolutionsList = [];
      if (this.otherSolutionsRequest.error) {
        return;
      }
      for (const solution of this.otherSolutionsRequest.apiData) {
        this.otherSolutionsList.push(this.createSolutionListEntry(solution));
      }
      // update pagination data
      this.numberOfSolutionsPerPage = this.otherSolutionsList.length;
      this.maxIndex = this.numPages * this.numberOfSolutionsPerPage;

      if (this.solutionData) {
        const solutionIndex = this.otherSolutionsList.findIndex((solution) => solution.solutionId === this.solutionData.solutionId);
        if (solutionIndex !== -1) {
          this.setPreviousNextIndex(solutionIndex);
        }
      }

      this.solutionsListInited = true;
    },
    checkListForSolution: function(solution) {
      // check if solution has already been loaded, but due to changes moved in list
      // e.g. other users rated or commented
      const existingSolutionIndex = this.otherSolutionsList.findIndex((otherSolution) => solution.solutionId === otherSolution.solutionId);
      // if solution was already in list, remove this
      if (existingSolutionIndex > -1) {
        this.otherSolutionsList.splice(existingSolutionIndex, 1);
      }
      // add solution at the end
      this.otherSolutionsList.push(this.createSolutionListEntry(solution));
    },
    loadNext: function () {
      this.pageId++;
      this.loadOtherSolutions(this.pageId);
    },
    loadOtherSolutions: function (pageId) {
      if (pageId === 1) {
        this.otherSolutionsRequest = services.rankTheCodeService.getOtherSolutionRatings(this.taskId, this.view, pageId);
      }
      else {
        this.reloadOtherSolutions(pageId);
      }
    },
    reloadOtherSolutions: function (pageId) {
      this.moreOtherSolutionsRequest = services.rankTheCodeService.getOtherSolutionRatings(this.taskId, this.view, pageId);
    },
    addedRatingHandler: function (data) {
      this.updateSolutionRatingData(data);
    },
    createSolutionListEntry: function (solution){
      return {
        'isYourSolution': solution.isYourSolution ? true : false,
        'publicUserName': this.getUserName(solution.publicUserId),
        'profileImage': this.getProfileImage(solution.publicUserId),
        'rating': solution.averageRating,
        'ratingCount': solution.ratings.length,
        'commentCount': solution.quantityOfComments,
        'solutionId': solution.solutionId,
        'timeSolved': solution.timeSolved,
        'publicUserId': solution.publicUserId,
      };
    },
    updateSolutionRatingData: function (data) {
      const solutionId = data.solutionId;
      const existingSolutionIndex = this.otherSolutionsList.findIndex((solution) => solution.solutionId === solutionId);
      let solutionData = null;
      if (existingSolutionIndex > -1) {
        solutionData = this.otherSolutionsList[existingSolutionIndex];
      }
      else if (this.tmpSolutionMap.has(solutionId)) {
        solutionData = this.tmpSolutionMap.get(solutionId);
      }
      if (solutionData) {
        if (data.averageRating) {
          solutionData.rating = data.averageRating;
        }
        if (data.ratingCount) {
          solutionData.ratingCount = data.ratingCount;
        }
        if (data.commentCount) {
          solutionData.commentCount = data.commentCount;
        }
        if (data.addedCommentCount) {
          solutionData.commentCount += data.addedCommentCount;
        }
        if (this.currentSolutionId === solutionId) {
          this.solutionData = solutionData;
        }
      }
    },
    setPreviousNextIndex: function(index) {
      if (index === -1) {
        let solutionIndex = -1;
        if (this.lastSeenSolutionId) {
           solutionIndex = this.otherSolutionsList.findIndex((solution) => solution.solutionId === this.lastSeenSolutionId);
        }
        this.previousIndex = solutionIndex;
        this.nextIndex = -1;
        return;
      }
      this.previousIndex = Math.max(index - 1, -1);
      this.nextIndex = index + 1;
      if (this.nextIndex >= this.maxIndex) {
        this.nextIndex = -1;
      }
    },
    addSeenSolutionIds: function(solutionId) {
      this.seenSolutionIds.add(solutionId);
    },
    showSolutionByIndex: function(index) {
      // don't do anything is index is -1
      if (index === -1) {
        return;
      }
      // if solution is already loaded
      if (index < this.otherSolutionsList.length) {
        let solutionData = this.otherSolutionsList[index];
        // check if solution is in tmp solutions map and remove
        if (solutionData.taskId === this.taskId && this.tmpSolutionMap.has(solutionData.solutionId)) {
          this.tmpSolutionMap.delete(solutionData.solutionId);
        }
        this.showModal(solutionData);
        // update previous and next button
        this.setPreviousNextIndex(index);
        return;
      }
      // if solution is not in list
      if (this.pageId < this.numPages && !this.isLoadingMoreSolutions) {
        this.isLoadingMoreSolutions = true;
        this.nextIndex = -1;
        this.loadNext();
        // add index to request, so solution can be opened with enabled previous and next buttons
        this.moreOtherSolutionsRequest.nextIndex = index;
      }
    },
    showModal: function(solutionData) {
      this.taskSolutions = [];
      if (solutionData.publicUserId) {
        this.setTaskSolutions(solutionData.publicUserId);
      }
      this.solutionData = solutionData;
      // disable previous and next button
      this.setPreviousNextIndex(-1);
      this.currentSolutionId = solutionData.solutionId;
      this.lastSeenSolutionId = this.currentSolutionId;
      this.addSeenSolutionIds(this.currentSolutionId);
      this.isModalVisible = true;
      let htmlElement = document.body.parentNode;
      htmlElement.style.overflow = 'hidden';
    },
    setTaskSolutions: function(publicUserId) {
      if (this.challengeData.tasks.length < 2) {
        this.taskSolutions = [];
        return;
      }
      if (this.taskSolutionMap.has(publicUserId)) {
        this.taskSolutions = this.taskSolutionMap.get(publicUserId);
        return;
      }
      this.taskSolutions = [];
      this.taskSolutionsRequest = services.rankTheCodeService.getSolutionsOfUserForChallenge(this.challengeData.id, publicUserId);
      this.taskSolutionsRequest.publicUserId = publicUserId;
    },
    closeModal: function() {
      this.isModalVisible = false;
      this.currentSolutionId = null;
      this.solutionData = null;
      this.enableScrolling();
    },
    enableScrolling: function() {
      let htmlElement = document.body.parentNode;
      htmlElement.style.removeProperty('overflow');
    },
    getPublicUserIds: function (apiData) {
      const publicUserIds = [];
      for (const solution of apiData) {
        publicUserIds.push(solution.publicUserId);

        if (solution.ratings) {
          for (const rating of solution.ratings) {
            publicUserIds.push(rating.publicUserId);
          }
        }
      }
      return publicUserIds;
    },
    getUserName: function(publicUserId) {
      if (!this.publicUserIdMap.has(publicUserId)) {
        return "Anonymer EntwicklerHeld";
      }
      return this.publicUserIdMap.get(publicUserId)["displayName"];
    },
    getProfileImage: function(publicUserId) {
      if (!this.publicUserIdMap.has(publicUserId)) {
        return "https://s3.amazonaws.com/s3-cuescience/anonym-user.png";
      }
      return this.publicUserIdMap.get(publicUserId)["profilePicture"];
    },
    createPublicUserIdMap: function(publicUsersData) {
      publicUsersData.forEach(publicUserData => this.publicUserIdMap.set(publicUserData.publicUserId, {
        displayName: publicUserData.displayName,
        profilePicture: publicUserData.profilePicture
      }));
    },
  }
}
</script>

<style scoped>
.flex {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.panel-list {
  margin: 0 1.5rem;
  max-width: 120rem;
}

.panel-list .panel.panel-clickable {
  cursor: pointer;
}

.panel-list .panel.panel-clickable.seen .nickname {
    color: #bdc3c7;
}

.last-seen {
    border: #bdc3c7 2px solid;
}

.profile-image {
  margin-right: 1rem;
  border-radius: 99px;
  height: 25px;
  width: 25px;
}

.nickname {
  overflow-x: hidden;
}

.date {
  font-size: smaller;
  color: grey;
}

::v-deep .star-rating-col .star-rating__star {
  padding-left: 0;
  margin-bottom: 0;
}

::v-deep .star-rating-col .star-rating {
  margin-right: 1rem;
}

@media (max-width: 477px) {
  .panel-body {
    padding-left: 0;
    padding-right: 0;
  }
}

.icon {
  margin-right: .5rem;
  font-size: 1.3rem;
}

a {
  cursor: pointer;
}

.error-message {
  padding: 1.5rem;
  margin-left: 3rem;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.error-icon {
  height: 3rem;
  margin-right: 2rem;
}

@media (max-width: 500px) {
  ::v-deep .star-rating-col .star-rating {
    margin-right: 0;
  }

  ::v-deep .star-rating-col .star-rating__star {
    padding-left: 0;
    padding-right: 0;
  }
}
</style>